module.exports = __webpack_public_path__ + "static/img/t-one.8e48116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-six/t-one.png
// module id = f1Ev
// module chunks = 0